import * as echarts from 'echarts/core';
// import necessary echarts components
import {
  DatasetComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';

import { BarChart, LineChart, PieChart, RadarChart } from 'echarts/charts';
import { LabelLayout } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
// import { SVGRenderer } from 'echarts/renderers';

echarts.use([
  DatasetComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
  LineChart,
  BarChart,
  PieChart,
  RadarChart,
  CanvasRenderer,
  // SVGRenderer,
  LabelLayout,
]);

export { echarts };
